import axios from "axios";
import { API_URL } from "../const/config";

const api = axios.create({
    baseURL: API_URL + "/api",
});

export class dropdownService {
    // Pass a "type" key, get back any dropdown VM you expect.
    static async getAll<T>(type: string): Promise<T[]> {
        const res = await api.get<T[]>(`/dropdown/${encodeURIComponent(type)}`);
        return res.data;
    }
}
